import { render, staticRenderFns } from "./SensitiveWords.vue?vue&type=template&id=2b93d4f1&scoped=true"
import script from "./SensitiveWords.vue?vue&type=script&lang=js"
export * from "./SensitiveWords.vue?vue&type=script&lang=js"
import style0 from "./SensitiveWords.vue?vue&type=style&index=0&id=2b93d4f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b93d4f1",
  null
  
)

export default component.exports